import {createApp, defineAsyncComponent} from 'vue';
import {i18n} from '../../setup/i18n';
import emitter from "../../setup/bus";
import {createPinia} from 'pinia';
import * as VueRouter from 'vue-router';

export default function initTeaser() {
    const instances = document.querySelectorAll('#app-search');
    Array.prototype.forEach.call(instances, el => {

        const pinia = createPinia();

        const app = createApp({});
        app.config.globalProperties.$bus = emitter;
        app.provide('$bus', emitter);


        const router = VueRouter.createRouter({
            history: VueRouter.createWebHashHistory(),
            routes: [
                {
                    path: '/:query?/:filter?',
                    name: 'Search',
                    component: (
                        'search',
                            () => import('./Search.vue')
                    ),
                },
            ],
        })

        app.use(pinia)
            .use(router)
            .use(i18n)
            .component(
                'search',
                defineAsyncComponent(() => import('./Search.vue'))
            )
            .mount(el);
    });
}
